import { Component, OnInit, ElementRef, ViewChild, AfterViewInit, ApplicationRef } from '@angular/core';
// import { TITLEROUTES } from '../sidebar/sidebar.component';
import { Location, DatePipe } from '@angular/common';
import { Router } from '@angular/router';
import { StorageService, StorageKey } from '../../shared/storage.service';
import { CookieService } from 'ngx-cookie-service';
import { CommonService } from '../../shared/common.service';
import { FormGroup, FormControl, FormArray, FormBuilder, Validators, ValidatorFn, ValidationErrors, AbstractControl } from '@angular/forms';
import { CoreHelperService } from '../../Providers/core-helper/core-helper.service';
import { environment } from '../../../environments/environment';
import { UserLayoutService } from '../../layouts/user-layout/user-layout.service';
import { Subscription } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { MustMatch } from '../../back-office/sign-up/must-match.validator';
import { LoginLayoutService } from '../../layouts/login-layout/login-layout.service';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { DomSanitizer } from '@angular/platform-browser';
import { OrganizationEnumModel } from '../../shared/constant/organization.model';
const currencies = require('../currencies.json');
const countryData = require('../../back-office/country-code.json');

declare const $: any;
declare var bootstrap: any;

@Component({
    selector: 'app-navbar',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.css']
})
export class NavbarComponent implements OnInit, AfterViewInit {
    profileLetter: any;
    profileImage: any;
    userDetail: any;
    searchTerm: string;
    PlaceList: any = [];
    dropDownVehiclelist: any = [];
    currencies = currencies;
    selectedCurrency = currencies[0];
    isDropdownOpen = false;
    whatsAppInquiryContact: string = '';
    private subscription!: Subscription;
    whatsAppInquirySubmitted: boolean = false;
    whatsappInquiryData = {
        adults: 1,
        children: 0,
        startDate: ''
    };

    //#region Login 
    loginForm: FormGroup;
    submitted = false;
    passwordFieldType: string = 'password';
    //#endregion 

    //#region Forgot Password 
    forgotPasswordForm: FormGroup;
    //#endregion

    //#region Forgot Password OTP
    otpForm: FormGroup;
    validForm = true;
    userData: any;
    userId: string = '';
    isForgotPassword: boolean = false;
    // showResendButton: boolean = false;
    isResending: boolean = true;
    remainingSeconds: number = 60;
    resendTimeout: any;
    //#endregion

    //#region Sign up form
    signUpForm: FormGroup;
    showPassword = false;
    showConfirmPassword = false;
    passwordCriteria = {
        minLength: false,
        upperCase: false,
        lowerCase: false,
        number: false,
        specialChar: false,
    };
    showPopup = false;
    isPasswordValid = false;
    //#endregion

    //#region Reset Password
    resetPasswordForm: FormGroup;
    password: string = 'password';
    //#endregion
    countryData = countryData;

    // custom request area
    customInqForm: FormGroup;
    customInqSubmitted = false;
    selectedRequestType: any = '';
    tripType: any = 'OneWay';
    minStartDate = new Date();
    minEndDate = new Date();
    //   PlaceList = []; 
    //   countryData = []; 
    datePickerConfig: Partial<BsDatepickerConfig>;
    vehicleTripType: string = 'OneWay';

    explorationData: any = [];
    selectedContent: any = [];
    selectedCategoryIndex = 0;
    selectedDestinationIndex = 0;
    explorationFeature: boolean = false;

    constructor(
        location: Location,
        private element: ElementRef,
        private fb: FormBuilder,
        public router: Router,
        public storageService: StorageService,
        public commonService: CommonService,
        public userLayoutService: UserLayoutService,
        private http: HttpClient,
        public loginLayoutService: LoginLayoutService,
        private appRef: ApplicationRef,
        private datePipe: DatePipe,
        private sanitizer: DomSanitizer
    ) { }

    ngOnInit() {
        this.getOrganizationAttributes();
        this.datePickerConfig = {
            containerClass: 'theme-dark-blue',
            dateInputFormat: 'MMM DD, YYYY',
            showWeekNumbers: false
        };
        const organizationAttributes = JSON.parse(localStorage.getItem('organizationAttributes'));
        const explorationFeature = organizationAttributes?.find((attr: any) => attr.attributeName === OrganizationEnumModel.enableExplorationFeature);
        if (explorationFeature && explorationFeature.value !== null) {
            this.explorationFeature = explorationFeature.value;
            // this.explorationFeature = true;
        }
        this.subscription = this.commonService.loginUserData$.subscribe((userData) => {
            if (userData && userData.profileImage) {
                this.userDetail = userData;
                this.profileImage = `${this.commonService.rootData.rootFilePath}${userData.profileImage}`;
                this.profileLetter = null; // Reset letter when image is available
            } else if (userData && userData.firstName) {
                this.userDetail = userData;
                this.profileImage = null;
                this.profileLetter = userData.firstName.charAt(0).toUpperCase();
            } else {
                this.userDetail = null;
                this.profileImage = null;
                this.profileLetter = null;
            }
        });
        const currency = localStorage.getItem('currencyCode');
        this.selectedCurrency = this.currencies.find(c => c.currencyCode === (currency ? currency : 'USD'));
        this.defaultAddCustomInqForm();
        this.autoDetectCurrency();
        this.getPlaceListData();
        this.getVehicleListData();


        this.defaultLoginForm();
        this.defaultforgotpassform();
        this.defaultsignupForm();
        this.defaultOTPForm();
        this.defualtResetPass();
    }

    ngAfterViewInit(): void {
        $('.menu-toggle').click(function () {
            $(this).toggleClass('active');
            $('.menu-content').slideToggle(500);
        });
        this.initloginSliderSlick()
    }
    initloginSliderSlick(): void {
        if ($('.login_slider').hasClass('slick-initialized')) {
            $('.login_slider').slick('unslick'); // Destroy existing instance
        }
        $('.login_slider').slick({
            dots: true, // Show dots navigation
            arrows: false, // Hide arrow navigation
            infinite: true, // Infinite looping
            speed: 500, // Transition speed (ms)
            fade: false, // Don't use fade effect
            cssEase: 'linear', // Transition easing
            autoplay: true, // Enable autoplay
            autoplaySpeed: 2000, // Autoplay interval (ms) - adjust as needed
            pauseOnHover: false, // Continue autoplay on hover
            pauseOnFocus: false, // Continue autoplay when focus
            slidesToShow: 1,
            slidesToScroll: 1,
            adaptiveHeight: false,
            centerMode: false
        });

        // Main tab buttons
        // $(".placeTablist li button").click(function () {
        //     $(".placeTablist li button").removeClass("active");
        //     $(this).addClass('active');
        // });


        // $(document).on('click', '.subplaceList button', function () {
        //     $(".subplaceList button").removeClass("active");
        //     $(this).addClass('active');
        //     var selectedText = $(this).text();
        //     $("#explorarTitle").text(selectedText);
        //     localStorage.setItem('lastSelectedButton', selectedText);
        // });

        // Main content tabs
        // $('.explorarContent').hide(); // Hide all by default
        // $('#somnathContent').show().addClass('contentActive'); // Show default

        // function changeMainTab(target) {
        //     $('.explorarContent.contentActive').fadeOut(300, function () {
        //         $(this).removeClass('contentActive');
        //         $('#' + target).fadeIn(300).addClass('contentActive');
        //     });
        // }

        // $('.somnathBtn').click(function () {
        //     changeMainTab('somnathContent');
        // });
        // $('.mallikarjunaBtn').click(function () {
        //     changeMainTab('mallikarjunaContent');
        // });

        // Subplace list changer
        // $('.subplacelistitems').hide(); // Hide all by default
        // $('#jyotirlinga1subitem').show().addClass('subplacelistActive'); // Show default

        // function changeSubTab(target) {
        //     $('.subplacelistitems.subplacelistActive').fadeOut(300, function () {
        //         $(this).removeClass('subplacelistActive');
        //         $('#' + target).fadeIn(300).addClass('subplacelistActive');
        //     });
        // }

        // $('.jyotirlinga1btn').click(function () {
        //     changeSubTab('jyotirlinga1subitem');
        // });
        // $('.jyotirlinga2btn').click(function () {
        //     changeSubTab('jyotirlinga2subitem');
        // });
        // $('.shaktiPithbtn').click(function () {
        //     changeSubTab('shaktipitharea');
        // });
        document.addEventListener('keydown', this.handleEscapeKey);

    }
    private handleEscapeKey = (event: KeyboardEvent) => {
        if (event.key === 'Escape') {
            this.removebackdrop();
        }
    };

    navigateToProfile(): void {
        this.router.navigate(['/profile']);
    }

    logout() {
        localStorage.removeItem('LoginUserData');
        localStorage.removeItem('_id');
        localStorage.removeItem('profileImage');
        this.storageService.removeValue(StorageKey.myToken);
        this.router.navigate(['/home']);
        this.commonService.notifier.notify('success', 'User logged out successfully');
        window.location.reload();
    }

    getPlaceListData() {
        this.userLayoutService.getPlaceList().subscribe((Response: any) => {
            if (Response.code == 1) {
                this.PlaceList = Response.data;
            } else {
                console.warn("Failed to retrieve category details");
            }
        }, (error) => {
            console.error("Error fetching category details:", error.error.Message);
        });
    }

    getVehicleListData() {
        this.userLayoutService.getVehicleListCustomDropDown().subscribe((Response: any) => {
            if (Response.code == 1) {
                this.dropDownVehiclelist = Response.data.vehicles;
            } else {
                console.warn("Failed to retrieve category details");
            }
        }, (error) => {
            console.error("Error fetching category details:", error.error.Message);
        });
    }
    //#region Exploration
    getExplorationData() {
        this.userLayoutService.getExplorationData().subscribe((Response: any) => {
            if (Response.code == 1) {
                this.explorationData = Response.data.categories;
                setTimeout(() => {
                    this.onCategorySelect(0);
                }, 100);
            } else {
                console.warn("Failed to retrieve category details");
            }
        }, (error) => {
            console.error("Error fetching category details:", error.error.Message);
        });
    }

    onCategorySelect(index: any) {
        this.selectedCategoryIndex = index;
        this.selectedDestinationIndex = 0;
        this.onDestinationSelect(this.selectedDestinationIndex);

        // Use setTimeout to ensure DOM is updated before manipulating animation
        setTimeout(() => {
            const marqueeContainer = document.getElementById('subPlaceItem');
            const marqueeContent = marqueeContainer?.querySelector('.expmarquee-content') as HTMLElement;

            if (marqueeContent) {
                marqueeContent.style.animation = 'none';
                void marqueeContent.offsetWidth;
                setTimeout(() => {
                    marqueeContent.style.animation = 'marquee 15s linear infinite';
                }, 50);
            }

            // jQuery cleanup and reinit
            const $activeItems = $('.subplacelistitems.subplacelistActive');

            // Stop current animations and queues
            $activeItems.stop(true, true).fadeOut(300, () => {
                $('.subplacelistitems').removeClass('subplacelistActive');

                // Ensure previous animations are cleared
                const $newItem = $('#subPlaceItem');
                $newItem.stop(true, true).fadeIn(300).addClass('subplacelistActive');
            });

        }, 0);
    }


    onDestinationSelect(index: any) {
        this.selectedDestinationIndex = index;
        this.selectedContent = this.explorationData[this.selectedCategoryIndex]?.destinations[this.selectedDestinationIndex];
        const originalUrl = this.selectedContent?.youtubeLink;

        // Convert normal YouTube URL to embed format
        const videoId = this.extractYouTubeVideoId(originalUrl);
        const embedUrl = `https://www.youtube.com/embed/${videoId}`;

        // Sanitize the embed URL
        this.selectedContent.youtubeLink = this.sanitizer.bypassSecurityTrustResourceUrl(embedUrl);
    }

    extractYouTubeVideoId(url: string): string | null {
        const regExp = /^.*(?:youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
        const match = url.match(regExp);
        return (match && match[1].length === 11) ? match[1] : null;
    }

    //#endregion
    onPlaceSelect() {
        if (this.searchTerm) {
            // API Call
            let param = {
                searchTerm: this.searchTerm,
            }

            // Send the inquiry request
            this.userLayoutService.getPackagesDetailsBySearchTerm(param).subscribe(
                (Response: any) => {

                    if (Response.code === 1) {
                        this.router.navigate(['home']);
                        this.router.navigate(['/packages'], { queryParams: { place: this.searchTerm } });
                        this.searchTerm = null;
                    } else {
                        this.router.navigate(['home']);
                        this.searchTerm = null;
                        this.commonService.notifier.notify('error', Response.message);
                    }
                },
                (error) => {
                    this.router.navigate(['home']);
                    this.searchTerm = null;
                    this.commonService.notifier.notify('error', error);
                }
            );
        }
    }

    autoDetectCurrency() {
        // debugger
        if (localStorage.getItem('currencyCode')) {
            this.onCurrencySelect();
        } else {
            this.http.get<any>('https://ipinfo.io/?token=79f7967356dc44').subscribe(
                (location) => {
                    const countryCode = location.country;

                    // Map country code to currency code
                    const currencyMapping: { [key: string]: string } = {
                        US: 'USD',
                        IN: 'INR',
                        GB: 'GBP',
                        AU: 'AUD',
                        CA: 'CAD',
                        EU: 'EUR' // or use region-based logic
                    };

                    const currencyCode = currencyMapping[countryCode] || 'USD'; // fallback to USD
                    const matchedCurrency = this.currencies.find(c => c.currencyCode === currencyCode);

                    if (matchedCurrency) {
                        this.selectedCurrency = matchedCurrency;
                        this.onCurrencySelect(); // call your existing function
                    }
                },
                (error) => {
                    console.error('Failed to fetch user location, defaulting to USD.', error);
                    this.selectedCurrency = this.currencies.find(c => c.currencyCode === 'USD');
                    this.onCurrencySelect();
                }
            );
        }
        // this.onCurrencySelect();

    }

    onCurrencySelect() {
        if (localStorage.getItem('currencyCode') != this.selectedCurrency?.currencyCode) {
            if (this.selectedCurrency?.currencyCode == 'USD') {
                let currencyRates;
                currencyRates = 1;
                this.commonService.currencyConversionRate = currencyRates;
                this.commonService.currencySymbol = this.selectedCurrency?.currencySymbol;
                this.commonService.currentCurrency = this.selectedCurrency?.currencyCode;
                localStorage.setItem('currencyCode', this.selectedCurrency?.currencyCode);
                localStorage.setItem('currencyRate', currencyRates);
            } else {
                this.http.get<any[]>('https://api.currencybeacon.com/v1/latest?api_key=Qh1fB6qhHX2kgLh2Cc3mfBrAX6oYW5zF').subscribe(
                    (data: any) => {
                        let currencyRates = data.rates[this.selectedCurrency?.currencyCode];
                        this.commonService.currencyConversionRate = currencyRates;
                        this.commonService.currencySymbol = this.selectedCurrency?.currencySymbol;
                        this.commonService.currentCurrency = this.selectedCurrency?.currencyCode;
                        localStorage.setItem('currencyCode', this.selectedCurrency?.currencyCode);
                        localStorage.setItem('currencyRate', currencyRates);
                    },
                    (error) => {
                        let currencyRates = this.selectedCurrency?.exchangeRate;
                        this.commonService.currencyConversionRate = currencyRates;
                        this.commonService.currencySymbol = this.selectedCurrency?.currencySymbol;
                        this.commonService.currentCurrency = this.selectedCurrency?.currencyCode;
                        localStorage.setItem('currencyCode', this.selectedCurrency?.currencyCode);
                        localStorage.setItem('currencyRate', currencyRates);
                    }
                );
            }
            setTimeout(() => {
                window.location.reload();
            }, 1000);
        } else {
            let currencyRates = localStorage.getItem('currencyRate');
            this.commonService.currencyConversionRate = currencyRates;
            this.commonService.currencySymbol = this.selectedCurrency?.currencySymbol;
            this.commonService.currentCurrency = this.selectedCurrency?.currencyCode;
        }
    }

    getOrganizationAttributes() {
        this.userLayoutService.getOrganizationAttributesData().subscribe((Response: any) => {
            if (Response.code == 1) {
                const attributes = Response.data
                localStorage.setItem('organizationAttributes', JSON.stringify(Response.data));
                const taxAttribute = attributes.find((attr: any) => attr.attributeName === OrganizationEnumModel.package_summary_payment_details_tax);
                if (taxAttribute && taxAttribute.customValue !== null) {
                    this.commonService.taxRatio = parseFloat(taxAttribute.customValue);
                }
            } else {
                console.warn("Failed to retrieve category details");
            }
        }, (error) => {
            console.error("Error fetching category details:", error.error.Message);
        });
    }


    // #region Login 

    defaultLoginForm() {
        this.loginForm = this.fb.group({
            email: ['', [Validators.required, Validators.email]],
            password: ['', [Validators.required, Validators.minLength(6)]]
        });
        this.submitted = false;

    }

    get f() {
        return this.loginForm.controls;
    }

    onLoginClick(): void {
        this.submitted = true;

        if (this.loginForm.invalid) {
            // console.log("Form is invalid");
            return;
        }

        //console.log("Login form submitted");
        this.loginLayoutService.UserLogin(this.loginForm.value).subscribe(
            (response: any) => {
                if (response.code === 1) {
                    localStorage.clear();
                    // localStorage.setItem('LoginUserData', JSON.stringify(response.data));
                    this.commonService.updateLoginUserData(response.data);
                    this.storageService.setValue(StorageKey.myToken, response.data.token);
                    this.storageService.setValue(StorageKey.id, response.data.id);
                    this.commonService.notifier.notify('success', 'User logged in successfully.');
                    this.openModal('', 'loginNow');
                    window.location.reload();
                    // this.router.navigate(['/home']);
                } else {
                    this.commonService.notifier.notify('error', response.message);
                }
            },
            (error) => {
                // console.log('API Error:', error);
                this.commonService.notifier.notify('error', 'Something went wrong. Please try again.');
            }
        );
    }

    togglePasswordVisibility(): void {
        this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
    }
    //#endregion

    //#region Forgot Password
    defaultforgotpassform() {
        this.forgotPasswordForm = this.fb.group({
            email: ['', [Validators.required, Validators.email]]
        });
        this.submitted = false;
    }

    get forgotpassf() {
        return this.forgotPasswordForm.controls;
    }

    onForgotPassSubmit() {
        this.submitted = true;

        if (this.forgotPasswordForm.invalid) {
            return;
        }

        const emailData = this.forgotPasswordForm.value;

        this.loginLayoutService.forgotPassword(emailData).subscribe(
            (Response: any) => {
                if (Response.code === 1) {
                    this.commonService.notifier.notify('success', 'Password reset instructions sent to your email.');
                    this.isForgotPassword = true;
                    this.userId = Response.data.userId
                    this.openModal('otpArea', 'forgotPassword')

                    //   this.router.navigate(['reset-password-verify-otp'], {
                    //     queryParams: { userId: Response.data.userId, isForgotPassword: true }
                    // });
                } else {
                    this.commonService.notifier.notify('error', Response.message);
                }
            },
            (error) => {
                // console.log('API Error:', error); // Log error to the console
                this.commonService.notifier.notify('error', 'Something went wrong. Please try again.');
            }
        );
    }
    //#endregion

    //#region Sign Up form 
    defaultsignupForm() {
        this.signUpForm = this.fb.group({
            firstName: ['', [Validators.required, Validators.minLength(2)]],
            lastName: ['', [Validators.required, Validators.minLength(2)]],
            email: ['', [Validators.required, this.customEmailValidator()]],
            mobilenumber: ['', [Validators.required, Validators.pattern(/^\d{10}$/)]],
            countrycode: ['+1', [Validators.required]],
            password: ['', [Validators.required, Validators.minLength(8)]],
            confirmPassword: ['', Validators.required]
        }, {
            validator: MustMatch('password', 'confirmPassword')
        });
        this.submitted = false;
    }
    validatePassword() {
        const value = this.signUpForm.get('password')?.value || '';
        this.passwordCriteria.minLength = value.length >= 8;
        this.passwordCriteria.upperCase = /[A-Z]/.test(value);
        this.passwordCriteria.lowerCase = /[a-z]/.test(value);
        this.passwordCriteria.number = /[0-9]/.test(value);
        this.passwordCriteria.specialChar = /[@$!%*?&#^(){}[\]]/.test(value);

        this.isPasswordValid = this.allCriteriaMet();

        if (this.isPasswordValid) {
            this.showPopup = false;
        }

        // if (this.allCriteriaMet()) {
        //   this.showPopup = false;
        // }

        // console.log('Validation Status:', this.passwordCriteria);
        // Force a change detection cycle
        this.appRef.tick();
    }

    //showPopup = true;

    // Hide popup
    hidePopup() {
        this.showPopup = false;
    }

    allCriteriaMet(): boolean {
        return (
            this.passwordCriteria.minLength &&
            this.passwordCriteria.upperCase &&
            this.passwordCriteria.lowerCase &&
            this.passwordCriteria.number &&
            this.passwordCriteria.specialChar
        );
    }

    focusPasswordInput(): void {
        if (!this.isPasswordValid) {
            this.showPopup = true;
        }
    }

    signupmobilenumberInput(event: any, formName: string, controlName: string): void {
        const input = event.target;

        // Allow only numeric values (0-9)
        input.value = input.value.replace(/[^0-9]/g, '');

        // Update the form control value
        this[formName].patchValue({
            [controlName]: input.value || null,
        });
    }

    signupSearchByName(term: string, item: any): boolean {
        term = term.toLowerCase();
        return item.name.toLowerCase().includes(term) || item.dial_code.toLowerCase().includes(term) || item.code.toLowerCase().includes(term);
    }


    onAlphabeticInput(event: any): void {
        const input = event.target;
        input.value = input.value.replace(/[^A-Za-z ]/g, '');
    }


    signuptogglePasswordVisibility(): void {
        this.showPassword = !this.showPassword;
    }

    toggleConfirmPasswordVisibility(): void {
        this.showConfirmPassword = !this.showConfirmPassword;
    }


    get SignUpf() {
        return this.signUpForm.controls;
    }

    onSignUpSubmit() {
        // console.log("onsubmit");
        this.submitted = true;

        // if (this.signUpForm.invalid) {
        //   console.log("return")
        //   return;
        // }

        const signUpData = this.signUpForm.value;

        if (this.signUpForm.valid) {
            this.loginLayoutService.signUp(signUpData).subscribe(
                (Response: any) => {
                    if (Response.code === 1) {
                        this.commonService.notifier.notify('success', Response.message);
                        this.storageService.setValue('userData', JSON.stringify(Response.data));
                        this.openModal('otpArea', 'signupNow')
                        //this.router.navigate(['otp-verification']);
                    } else {
                        this.commonService.notifier.notify('error', Response.message);
                    }
                },
                (error) => {
                    console.error("API Error:", error);
                    // this.errorMessage = "Something went wrong. Please try again.";
                    // this.commonService.notifier.notify('error', this.errorMessage);
                }
            );
        }

    }
    //#endregion

    //#region OTP form 
    defaultOTPForm() {

        this.userData = JSON.parse(this.storageService.getValue('userData'));
        // Initialize OTP form
        this.otpForm = this.fb.group({
            otp1: ['', [Validators.required, Validators.minLength(1)]],
            otp2: ['', [Validators.required, Validators.minLength(1)]],
            otp3: ['', [Validators.required, Validators.minLength(1)]],
            otp4: ['', [Validators.required, Validators.minLength(1)]]
        });

        this.startCountdown();
        this.submitted = false;
    }

    // Getter for form controls
    get OTPf() {
        return this.otpForm.controls;
    }

    // Combine OTP digits into one string
    get otpCode(): string {
        return `${this.OTPf.otp1.value}${this.OTPf.otp2.value}${this.OTPf.otp3.value}${this.OTPf.otp4.value}`;
    }

    // Handle OTP form submission
    onOTPSubmit() {
        this.userData = JSON.parse(this.storageService.getValue('userData'));
        this.submitted = true;

        // Stop if the form is invalid
        if (this.otpForm.invalid) {
            // console.log("invalid form")
            return;
        }
        this.validForm = false;
        const otpData = {
            userId: this.isForgotPassword ? this.userId : this.userData.id,
            otpCode: this.otpCode
        };


        if (!this.isForgotPassword) {

            this.loginLayoutService.verifyOtp(otpData).subscribe((Response: any) => {
                if (Response.code == 1) {
                    // OTP verification successful
                    this.commonService.notifier.notify('success', 'OTP verified successfully.');
                    this.openModal('loginNow', 'otpArea')
                    //this.router.navigate(['login']);
                } else {
                    this.commonService.notifier.notify('error', Response.message);
                }
            }, (error) => {
                // console.log(error);
                this.commonService.notifier.notify('error', 'Failed to verify OTP. Please try again.');
            });
        } else if (this.isForgotPassword) {

            this.loginLayoutService.forgotverifyOtp(otpData).subscribe(
                (Response: any) => {
                    if (Response.code === 1) {
                        this.openModal('newPassword', 'otpArea')
                        // Navigate to the Reset Password page
                        //this.router.navigate(['reset-password'], { queryParams: { userId: this.userId } });
                    } else {
                        this.commonService.notifier.notify('error', Response.message);
                    }
                },
                (error) => {
                    // console.log('API Error:', error); // Log error to the console
                    this.commonService.notifier.notify('error', 'Something went wrong. Please try again.');
                }
            );
        } else {
            // console.log("Wrong Params or Situation");
        }

    }

    onResendOtp() {
        this.isResending = true;
        this.remainingSeconds = 60;

        if (!this.isForgotPassword) {
            const otpData = {
                userId: this.userData.id,
            };

            // Call your service to resend OTP
            this.loginLayoutService.resendOtp(otpData).subscribe((Response: any) => {
                if (Response.code == 1) {
                    this.commonService.notifier.notify('success', 'OTP resent to your email.');
                } else {
                    this.commonService.notifier.notify('error', Response.message);
                }
            },
                error => {
                    // console.log('API Error:', error);
                    this.commonService.notifier.notify('error', 'Something went wrong. Please try again.');
                }
            );
        } else if (this.isForgotPassword) {
            const otpData = {
                userId: this.userId,
            };

            // Call your service to resend OTP
            this.loginLayoutService.forgotResendOtp(otpData).subscribe((Response: any) => {
                if (Response.code == 1) {
                    this.commonService.notifier.notify('success', 'OTP resent to your email.');
                } else {
                    this.commonService.notifier.notify('error', Response.message);
                }
            },
                error => {
                    // console.log('API Error:', error);
                    this.commonService.notifier.notify('error', 'Something went wrong. Please try again.');
                }
            );
        } else {
            // console.log("Wrong API calling");
        }

        // Start countdown for resend button
        this.startCountdown();
    }

    startCountdown() {
        this.resendTimeout = setInterval(() => {
            this.remainingSeconds--;

            if (this.remainingSeconds <= 0) {
                clearInterval(this.resendTimeout);
                this.isResending = false;
            }
        }, 1000);
    }

    // Optional: Auto-focus to the next OTP input
    onKeyUpEvent(event: any, index: number) {
        const inputs = document.getElementsByClassName('otp-field') as HTMLCollectionOf<HTMLInputElement>;
        if (event.target.value.length === 1 && index < inputs.length - 1) {
            inputs[index + 1].focus();
        }
        if (event.key === 'Backspace' && index > 0 && event.target.value === '') {
            inputs[index - 1].focus();
            inputs[index - 1].value = '';
        }

        if (this.otpForm.valid) {
            this.validForm = false
        } else {
            this.validForm = true;
        }
    }

    //#endregion

    //#region Reset Password
    defualtResetPass() {
        this.resetPasswordForm = this.fb.group({
            password: ['', [Validators.required, Validators.minLength(6)]],
            confirmPassword: ['', [Validators.required]]
        }, { validator: this.passwordMatchValidator });
        this.submitted = false;
    }

    get ResetPassf() {
        return this.resetPasswordForm.controls;
    }

    passwordMatchValidator(form: FormGroup) {
        return form.get('password')?.value === form.get('confirmPassword')?.value
            ? null : { mismatch: true };
    }

    onResetSubmit() {
        this.submitted = true;

        if (this.resetPasswordForm.invalid) {
            return;
        }

        const resetData = {
            userId: this.userId,
            password: this.resetPasswordForm.value.password
        };

        this.loginLayoutService.resetPassword(resetData).subscribe(
            (Response: any) => {
                if (Response.code === 1) {
                    this.commonService.notifier.notify('success', 'Password reset successfully.');
                    // this.removebackdrop()
                    this.openModal('loginNow', 'newPassword')
                } else {
                    this.commonService.notifier.notify('error', Response.message);
                }
            },
            (error) => {
                // console.log('API Error:', error); 
                this.commonService.notifier.notify('error', 'Something went wrong. Please try again.');
            }
        );
    }

    togglePasswordVisibility1(): void {
        this.password = this.password === 'password' ? 'text' : 'password';
    }
    //#endregion

    removebackdrop() {    // Cleanup fallback after hiding
        setTimeout(function () {
            $('.modal-backdrop').remove();
            // $(this).closest('.modal').modal('hide');
            const openModalEl = document.querySelector('.modal.show');
            if (openModalEl) {
                const modalInstance = bootstrap.Modal.getInstance(openModalEl);
                modalInstance?.hide();
            }
        }, 300);
    }

    openModal(modalId: string, closeId?: string) {
        if (closeId) {
            const closeModalEl = document.getElementById(closeId);
            const closeModalInstance = bootstrap.Modal.getInstance(closeModalEl);
            if (closeModalInstance) {
                closeModalInstance.hide();
            }
        }
        this.defaultLoginForm();
        this.defaultsignupForm();
        this.defaultforgotpassform();
        this.defaultOTPForm();


        const modalEl = document.getElementById(modalId);
        const modal = new bootstrap.Modal(modalEl);
        modal.show();
    }

    // trimWhitespace(event: any): void {
    //     const input = event.target;
    //     input.value = input.value.trim();
    // }

    // customEmailValidator(): ValidatorFn {
    //     return (control: AbstractControl): ValidationErrors | null => {
    //         const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    //         const isValidEmail = emailPattern.test(control.value);
    //         return isValidEmail ? null : { 'invalidEmail': true };
    //     };
    // }

    openCustomReq(type: string) {
        this.selectedRequestType = type;
        this.defaultAddCustomInqForm();
        $('#customizeInquiryFHV').modal('show');
    }

    defaultAddCustomInqForm(): void {
        this.customInqForm = this.fb.group({
            // Personal Information
            name: ['', Validators.required],
            email: ['', [Validators.required, this.customEmailValidator()]],
            countryCode: ['+1', Validators.required],
            contactNumber: ['', [Validators.required, Validators.pattern(/^\d{8,12}$/)]],
            isSameAsWhatsApp: [false],
            places: [[], Validators.required],
            comments: [''],

            // Traveler Information
            adults: [1, [Validators.required, Validators.min(1)]],
            children: [0, [Validators.required, Validators.min(0)]],
            infants: [0, [Validators.required, Validators.min(0)]],
            travelClass: ['Economy'],

            flightDetails: this.fb.array([]),

            hotelDetails: this.fb.array([]),

            vehicleDetails: this.fb.array([])
        });

        if (this.selectedRequestType === 'Flight') {
            this.createFlightSegment();
            this.tripType = 'Round';
            const firstFlightSegment = this.flightDetails.at(0) as FormGroup;
            if (this.tripType === 'OneWay') {
                firstFlightSegment.get('returnDate').disable();
            }
        } else if (this.selectedRequestType === 'Hotel') {
            this.createHotelSegment();
        } else if (this.selectedRequestType === 'Vehicle') {
            this.createVehicleSegment();
            this.vehicleTripType = 'OneWay';
            const firstVehicleSegment = this.vehicleDetails.at(0) as FormGroup;
            if (this.vehicleTripType === 'OneWay') {
                firstVehicleSegment.get('returnDate').disable();
            }
        }


        // Set initial min end date
        this.minEndDate.setDate(this.minStartDate.getDate() + 1);

        this.customInqSubmitted = false;
    }

    // Flight Segment Management
    createFlightSegment() {
        const control = this.customInqForm.get('flightDetails') as FormArray;
        control.push(this.fb.group({
            journeyStartCity: ['', Validators.required],
            journeyEndCity: ['', Validators.required],
            departureDate: ['', Validators.required],
            returnDate: ['']
        }));
    }

    // Hotel Segment Management
    createHotelSegment() {
        const control = this.customInqForm.get('hotelDetails') as FormArray;
        control.push(this.fb.group({
            hotelName: ['', Validators.required],
            place: ['', Validators.required],
            checkInDate: ['', Validators.required],
            checkOutDate: ['', Validators.required],
            numberOfRooms: [1, [Validators.required, Validators.min(1)]]
        }));
    }

    // Vehicle Segment Management
    createVehicleSegment() {
        const control = this.customInqForm.get('vehicleDetails') as FormArray;
        control.push(this.fb.group({
            vehicleName: [null, Validators.required],
            startCity: ['', Validators.required],
            endCity: ['', Validators.required],
            departureDate: ['', Validators.required],
            returnDate: ['']
        }));
    }


    get flightDetails(): FormArray {
        return this.customInqForm.get('flightDetails') as FormArray;
    }

    get vehicleDetails(): FormArray {
        return this.customInqForm.get('vehicleDetails') as FormArray;
    }

    get hotelDetails(): FormArray {
        return this.customInqForm.get('hotelDetails') as FormArray;
    }

    addFlightSegment(): void {
        // this.flightDetails.push(this.createFlightSegment());
        this.createFlightSegment();
    }

    removeFlightSegment(index: number): void {
        this.flightDetails.removeAt(index);
    }

    onTripTypeChange(): void {
        if (this.tripType === 'OneWay' || this.tripType === 'Round') {
            // Reset to single segment if switching from MultiCity
            while (this.flightDetails.length > 1) {
                this.flightDetails.removeAt(1);
            }

            // Enable/disable return date based on trip type
            const returnDateControl = this.flightDetails.at(0).get('returnDate');
            if (this.tripType === 'OneWay') {
                returnDateControl.disable();
                returnDateControl.reset();
            } else {
                returnDateControl.enable();
            }
        }
    }

    addVehicleSegment(): void {
        // this.vehicleDetails.push(this.createVehicleSegment());
        this.createVehicleSegment();
    }

    removeVehicleSegment(index: number): void {
        this.vehicleDetails.removeAt(index);
    }

    onVehicleTripTypeChange(): void {
        if (this.vehicleTripType === 'OneWay' || this.vehicleTripType === 'Round') {
            // Reset to single segment if switching from MultiCity
            while (this.vehicleDetails.length > 1) {
                this.vehicleDetails.removeAt(1);
            }

            // Enable/disable return date based on trip type
            const returnDateControl = this.vehicleDetails.at(0).get('returnDate');
            if (this.vehicleTripType === 'OneWay') {
                returnDateControl.disable();
                returnDateControl.reset();
            } else {
                returnDateControl.enable();
            }
        }
    }

    addHotelSegment(): void {
        // this.hotelDetails.push(this.createHotelSegment());
        this.createHotelSegment();
    }

    removeHotelSegment(index: number): void {
        this.hotelDetails.removeAt(index);
    }

    // Counter Functions
    increaseCount(field: string): void {
        const currentValue = this.customInqForm.get(field).value;
        this.customInqForm.get(field).setValue(currentValue + 1);
    }

    decreaseCount(field: string): void {
        const currentValue = this.customInqForm.get(field).value;
        const minValue = field === 'adults' ? 1 : 0;
        if (currentValue > minValue) {
            this.customInqForm.get(field).setValue(currentValue - 1);
        }
    }

    // Form Submission
    submitInquiry(): void {
        this.customInqSubmitted = true;
        if (this.customInqForm.invalid) {
            console.warn('Form is invalid. Missing or incorrect fields:');

            Object.keys(this.customInqForm.controls).forEach(field => {
                const control = this.customInqForm.get(field);
                if (control && control.invalid) {
                    console.warn(`- ${field}:`, control.errors);
                }
            });
        }
        if (this.customInqForm.valid) {
            const formValue = this.customInqForm.value;

            const payload: any = {
                name: formValue.name,
                email: formValue.email,
                countryCode: formValue.countryCode,
                contactNumber: formValue.contactNumber,
                isSameAsWhatsApp: formValue.isSameAsWhatsApp,
                adults: this.selectedRequestType !== 'Hotel' ? formValue.adults : null,
                children: this.selectedRequestType !== 'Hotel' ? formValue.children : null,
                infants: this.selectedRequestType !== 'Hotel' ? formValue.infants : null,
                comments: formValue.comments, // Optional, not in schema but safe to include if backend accepts
                places: formValue.places,
                tripType: this.selectedRequestType === 'Flight' ? this.tripType : (this.selectedRequestType === 'Vehicle' ? this.vehicleTripType : null),
                travelClass: this.selectedRequestType === 'Flight' ? formValue.travelClass : null,
                type: this.selectedRequestType.toLowerCase(),
                flightDetails: null,
                hotelDetails: null,
                vehicleDetails: null
            };

            switch (this.selectedRequestType.toLowerCase()) {
                case 'flight':
                    payload.flightDetails = formValue.flightDetails.map((detail: any) => ({
                        journeyStartCity: detail.journeyStartCity,
                        journeyEndCity: detail.journeyEndCity,
                        departureDate: this.formatDate(detail.departureDate),
                        returnDate: this.tripType === 'Round' ? this.formatDate(detail.returnDate) : null
                    }));
                    break;

                case 'hotel':
                    payload.adults = null; // Overriding top-level adults/children as these are now part of each hotel detail
                    payload.children = null;
                    payload.hotelDetails = formValue.hotelDetails.map((detail: any) => ({
                        hotelName: detail.hotelName,
                        place: detail.place,
                        adults: detail.adults,
                        children: detail.children,
                        checkInTime: this.formatDate(detail.checkInDate),
                        checkOutTime: this.formatDate(detail.checkOutDate),
                        numberOfRooms: detail.numberOfRooms
                    }));
                    break;

                case 'vehicle':
                    payload.vehicleDetails = formValue.vehicleDetails.map((detail: any) => ({
                        vehicleName: detail.vehicleName,
                        startCity: detail.startCity,
                        endCity: detail.endCity,
                        departureDate: this.formatDate(detail.departureDate),
                        returnDate: this.vehicleTripType === 'Round' ? this.formatDate(detail.returnDate) : null
                    }));
                    break;
            }

            this.userLayoutService.customFHVInquiry(payload).subscribe(
                (Response: any) => {
                    if (Response.code === 1) {
                        $('#customizeInquiryFHV').modal('hide');
                        setTimeout(() => {
                            $('.modal-backdrop').remove();
                            $('body').removeClass('modal-open');
                        }, 500);
                        this.commonService.notifier.notify('success', "We have received your request. MyYatra360 team will reach out to you at the earliest.");
                    } else {
                        this.commonService.notifier.notify('error', Response.message);
                    }
                },
                (error) => {
                    this.commonService.notifier.notify('error', error);
                }
            );
        }
    }



    // Helper Functions
    formatDate(date: any): string {
        if (!date) return null;
        const d = new Date(date);
        return d.toISOString();
    }

    customEmailValidator() {
        return (control: FormControl) => {
            const email = control.value;
            if (!email) {
                return null;
            }
            const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,4}$/;
            const valid = regex.test(email);
            return valid ? null : { invalidEmail: true };
        };
    }

    mobilenumberInput(event: any): void {
        const input = event.target;
        input.value = input.value.replace(/[^0-9]/g, '');
        this.customInqForm.patchValue({
            contactNumber: input.value || null,
        });
    }

    addCustomPlace = (term) => ({ id: term, names: term });

    searchByName(term: string, item: any): boolean {
        term = term.toLowerCase();
        return item.name.toLowerCase().includes(term) ||
            item.dial_code.toLowerCase().includes(term) ||
            item.code.toLowerCase().includes(term);
    }

    trimWhitespace(event: any): void {
        const input = event.target;
        input.value = input.value.trim();
        this.customInqForm.patchValue({
            email: input.value || null,
        });
    }

    redirecttoprofile() {
        this.router.navigate(['profile'])
    }

    openCustomInquiry() {
        $('#explorationPopup').modal('hide');
        this.router.navigate(['home'], { queryParams: { customInq: true } });
    }
    //#region Whatsapp
    openWhatsAppInquiry() {
        $('#explorationPopup').modal('hide'); $('.modal-backdrop').remove();
        this.whatsappInquiryData = {
            adults: 1,
            children: 0,
            startDate: ''
        };
        $('#navwhatsAppData').modal('show');
    }
    AddWhatsappInquiry() {
        this.whatsAppInquirySubmitted = true;
        let { adults, children, startDate } = this.whatsappInquiryData;
        if (adults > 0 && startDate) {
            //-------------------------------- Extract info-----------------------------------//
            startDate = this.datePipe.transform(startDate, 'dd MMMM, yyyy');
            const category = this.explorationData[this.selectedCategoryIndex].name
            const destinaton = this.explorationData[this.selectedCategoryIndex]?.destinations[this.selectedDestinationIndex].name
            const totalTravelers = `${adults} Adult${adults !== 1 ? 's' : ''}` +
                (children > 0 ? ` & ${children} Child${children > 1 ? 'ren' : ''}` : '');
            //-------------------------------- Extract info-----------------------------------//

            //--------------------------------MSG---------------------------------------------//
            const message = `Hi, I'm interested in ${category} for ${destinaton}.\n\n` +
                `Starting Date: ${startDate}\n` +
                `Travelers: ${totalTravelers}\n`;
            //--------------------------------MSG---------------------------------------------//

            //--------------------------------Whatsapp No.------------------------------------//
            const organizationAttributes = JSON.parse(localStorage.getItem('organizationAttributes'));
            if (this.selectedCurrency?.currencyCode == 'INR') {
                this.whatsAppInquiryContact = organizationAttributes.find((attr: any) => attr.attributeName === OrganizationEnumModel.indiaWhastAppNo && attr.value == true)?.customValue
            }
            else {
                this.whatsAppInquiryContact = organizationAttributes.find((attr: any) => attr.attributeName === OrganizationEnumModel.globalWhastAppNo && attr.value == true)?.customValue
            }
            const phoneNumber = this.whatsAppInquiryContact;
            //--------------------------------Whatsapp No.------------------------------------//

            //--------------------------------Encrypt Whatsapp------------------------------------//
            const encodedMessage = encodeURIComponent(message);
            const whatsappURL = `https://api.whatsapp.com/send?phone=${phoneNumber}&text=${encodedMessage}`;
            //--------------------------------Encrypt Whatsapp------------------------------------//

            $('#navwhatsAppData').modal('hide');
            window.open(whatsappURL, '_blank');
        } else {
            return;
        }
    }
    //#endregion
}
